import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;

	@media ${Breakpoints.mobile} {
		gap: 0;
		padding-top: 2rem;
	}
`;

export const TextWrapper = styled.div`
	margin-top: 2rem;

	@media ${Breakpoints.tablet} {
		margin-top: 0;
		padding: 2rem;
	}
`;
